const KEY = 'EVENT';
const PARTNER_KEY = ['EVENT', 'PARTNER'];
const CONTENTS_KEY = ['EVENT', 'CONTENTS'];
const ORGANIZATIONS_KEY = ['EVENT', 'ORGANIZATIONS'];

export { KEY, PARTNER_KEY, CONTENTS_KEY, ORGANIZATIONS_KEY };
